export default __webpack_public_path__ + "static/media/math.9c5b8a22.png";